module.exports = __webpack_public_path__ + "media/images/area/japanese-culture-41948192b05c83babbd9024f53d0ddbb.jpg";